import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { useStoreContext } from 'features/store';

import { selectors, useAppSelector } from 'state/global-state';
import { RewardRedemptionMethod } from 'state/loyalty/hooks/types';

interface IAppliedReward {
  rewardId: string;
  redemptionMethod: RewardRedemptionMethod;
  cartId: string;
  loyaltyEngineId?: string;
}

export const useAppliedReward = (): IAppliedReward | undefined => {
  const { store } = useStoreContext();
  const appliedReward = useAppSelector(selectors.loyalty.selectAppliedReward);
  const { getAppliedReward } = useMinimalCart();

  // Legacy stores
  if (!store.isOneMenu) {
    return appliedReward && appliedReward.sanityId
      ? {
          rewardId: appliedReward.sanityId,
          redemptionMethod: appliedReward.redemptionMethod,
          cartId: appliedReward.cartId,
          loyaltyEngineId: appliedReward.rewardId,
        }
      : undefined;
  }

  /**
   * 1M Stores
   *
   * If not applied reward is found on rewards slice, the reward could be on minimal cart only
   * when the user never hydrated the cart
   */
  if (appliedReward && appliedReward.sanityId) {
    return {
      rewardId: appliedReward.sanityId,
      redemptionMethod: appliedReward.redemptionMethod,
      cartId: appliedReward.cartId,
      loyaltyEngineId: appliedReward.rewardId,
    };
  }

  const minimalAppliedReward = getAppliedReward();

  return minimalAppliedReward
    ? // At this point, it's safe to assume the reward is for mobile redemption as in restaurant rewards
      // are added to the rewards slice even for 1M stores
      {
        rewardId: minimalAppliedReward.rewardId,
        redemptionMethod: RewardRedemptionMethod.MOBILE,
        cartId: minimalAppliedReward.cartId,
      }
    : undefined;
};
